import gql from 'graphql-tag';

export default gql`
fragment UserListItemFragment on User {
    id
    name
    email
    telephone
    ext_id
    last_login
    ip_address
    shipping_addresses {
        id
        name
        postcode
        city
        street
        house_number
        is_default
        note
        telephone
        is_goodid
    }
    orders(first: 1) {
        paginatorInfo {
            total
        }
    }
}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/fragments/UserListItemFragment.ts